module.exports = __webpack_public_path__ + "static/media/phone-office.316c7ccf.svg";